var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grapic-box",style:(_vm.styleVar)},_vm._l((_vm.dataItem.list),function(imgUrl,index){return _c('div',{key:index,staticClass:"txt-item"},[_c('img',{attrs:{"src":imgUrl}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }